const getTeamsRequestState = state => state.automationTab.teams.requestState;
export default getTeamsRequestState;